<template>
  <v-dialog
  v-model="model"
  :width="width"
  @click:outside="tryToCloseDialog"
  :persistent="isPersistent">
    <v-card
    color="white"
    width="100%">
      <div
      class="dialog--header d-flex justify-space-between align-center px-5"
      :style="`background-color: ${getHeaderColor};`">
        <span>{{$t(title)}}</span>
        <icon-button
        @click="closeDialog"
        src="close"
        color="white"/>
      </div>
      <v-progress-linear
      v-if="loading"
      indeterminate
      :color="getHeaderColor"/>
      <v-container>
        <slot/>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import IconButton from '@/components/btns/IconButton'
// import PrimaryBtn from '@/components/btns/PrimaryBtn'
export default {
  components: {
    // PrimaryBtn,
    IconButton
  },
  props: {
    value: Boolean,
    width: {
      type: [String, Number],
      default: 500
    },
    title: {
      type: String,
      required: true
    },
    headerBg: {
      type: String,
      default: "green" //[green, red, blue, darkBlue]
    },
    loading: {
      type: Boolean,
      default: false
    },
    exitable: {
      type: Boolean,
      default: true
    },
    overrideCloseDialog: {
      type: Function,
      default: null
    }
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  data() {
    return {

    }
  },
  watch: {
    "model": {
      handler(v) {
        this.$emit(v ? 'open' : 'close')
      },
      immediate: true
    }
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit('valueChanged', v)
      }
    },
    getHeaderColor() {
      switch(this.headerBg) {
        case "blue": return "#33b5e5"
        case "darkBlue": return "#0d47a1"
        case "red": return "#ff3547"
        default: return "#61c461"
      }
    },
    isPersistent() {
      return !this.exitable
    }
  },
  methods: {
    closeDialog() {
      if (this.overrideCloseDialog) this.overrideCloseDialog()
      else this.model = false
    },
    tryToCloseDialog() {
      if(this.isPersistent) return
      this.closeDialog()
    }
  }
}
</script>
<style>
.dialog--header {
  width: 100%;
  height: 70px;
  box-shadow: 0px 1px 5px 2px rgba(0, 0, 0, 0.144);
  border-radius: 0px!important;

  font-family: 'Titillium Web', sans-serif;
  color: white;
  font-weight: 300;
  font-size: 1.2rem;
  letter-spacing: 1px;
}
</style>
